var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.955 17.2292C13.955 15.5269 13.2788 13.8944 12.0751 12.6907C10.8714 11.487 9.23886 10.8108 7.53659 10.8108C5.83432 10.8108 4.20177 11.487 2.99808 12.6907C1.79439 13.8944 1.11816 15.5269 1.11816 17.2292H13.955Z",
    stroke: "#00A3FA",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5366 8.88655C9.66348 8.88655 11.3877 7.16237 11.3877 5.03549C11.3877 2.90861 9.66348 1.18443 7.5366 1.18443C5.40972 1.18443 3.68555 2.90861 3.68555 5.03549C3.68555 7.16237 5.40972 8.88655 7.5366 8.88655Z",
    stroke: "#00A3FA",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2002814dec1a44483084042b410649dc.svg";
export { ForwardRef as ReactComponent };